module.exports = __webpack_public_path__ + "static/media/Aave_AAVE.180b325d.png";